export { FooterComponent } from '@shared/layout/footer/footer.component';



// WEBPACK FOOTER //
// ./src/app/shared/layout/footer/index.ts